import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function StoreCta({ style }) {
  const { t } = useLanguage();

  return (
    <div className="store-cta" style={style}>
      <div className="cta-text">
        <strong>{t('mobileCta.title')}</strong>
        <span className="muted">{t('mobileCta.subtitle')}</span>
      </div>
      <div className="store-buttons">
        <a className="store-btn" href="https://apps.apple.com" target="_blank" rel="noreferrer">
          <svg className="store-icon" viewBox="-60 0 504 512" aria-hidden="true">
            <path
              fill="currentColor"
              d="M304.5 208.5c0 49.5 22.8 86.5 69 119.1-15.8 46.5-31.7 73.4-58.5 112.2-25.3 36.6-51.9 78.6-93.1 78.6-40.2 0-53.4-23.7-100.7-23.7-48.9 0-66.6 24.5-102.3 24.5-40.2 0-68.6-37-95.5-73.7-52.1-71.6-91.9-201.9-38.6-290.1 26.8-43.1 74.7-70.4 127.1-71.1 39.8-.7 77.3 26.1 100.7 26.1 22.8 0 65.2-32.3 110-27.6 18.9 .8 72 7.6 106.1 57.3-2.8 1.7-63.4 36.9-62.8 109.5zm-73.8-152.9c19.9-24.1 34.1-57.7 30.4-91.6-28.7 1.2-63.5 19.1-84.1 43.2-18.4 21.3-34.6 55.5-30.2 88.2 32.2 2.5 64-16.3 83.9-39.8z"
            />
          </svg>
          {t('mobileCta.appStore')}
        </a>
        <a className="store-btn" href="https://play.google.com/store" target="_blank" rel="noreferrer">
          <svg className="store-icon" viewBox="0 0 512 512" aria-hidden="true">
            <path fill="#34A853" d="M76 84l236 172L76 428V84z" />
            <path fill="#4285F4" d="M312 256l68-50 76 44c14 8 14 26 0 34l-76 44-68-50z" />
            <path fill="#FBBC05" d="M76 84l236 172 68-50L124 28c-18-12-48 0-48 26v30z" />
            <path fill="#EA4335" d="M76 428l236-172 68 50L124 484c-18 12-48 0-48-26v-30z" />
          </svg>
          {t('mobileCta.playStore')}
        </a>
      </div>
    </div>
  );
}
